import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from "@ashvin27/react-datatable";
import { addRoleData } from "../../actions/roleActions";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import $ from "jquery";
import classnames from "classnames";
import { baseUrl } from "../pages/baseUrl";
class PasswordChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      email: "",
      amount: "",
      role: "add",
      message: "",
      values: [],
      errors: {},
      type: "password",
    };
  }

  componentDidMount() {
    this.getData();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.auth.user.roleManager !== undefined &&
      this.props.auth.user.roleManager !== 1
    ) {
      this.props.history.push("/dashboard");
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    if (
      nextProps.roledata !== undefined &&
      nextProps.roledata.role !== undefined &&
      nextProps.roledata.role.data !== undefined &&
      nextProps.roledata.role.data.message !== undefined &&
      nextProps.roledata.role.data.success
    ) {
      //    this.props.history.push("/transaction");
    }
  }
  getData() {
    axios
      .post(baseUrl + "/api/role-manager-data")
      .then((res) => {
        this.setState({ records: res.data, id: res.data[0].id });
      })
      .catch();
  }
  handleClick = () =>
    this.setState(({ type }) => ({
      type: type === "text" ? "password" : "text",
    }));
  handleClick1 = () =>
    this.setState(({ type1 }) => ({
      type1: type1 === "text" ? "password" : "text",
    }));
  onChange = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value, errMsg: "" });
  };
  onUpdateBalance = (e) => {
    console.log(
      "ajdafkdsf",
      this.state.email,
      this.state.NewPassword,
      this.state.OldPassword,
      this.state.CPassword
    );
    e.preventDefault();
    axios
      .post(baseUrl + "/api/ChangePassword", {
        email: this.state.email,
        NewPassword: this.state.NewPassword,
        OldPassword: this.state.OldPassword,
        CPassword: this.state.CPassword,
      })
      .then((res) => {
        if (res.data.message) {
          toast(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });

          // this.props.history.push('/transaction');
        }
        if (res.data.email) {
          toast(res.data.email, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .catch();
  };

  render() {
    const { errors } = this.state;

    return (
      <div>
        <Navbar />
        <div className="d-flex" id="wrapper">
          <Sidebar />
          <div id="page-content-wrapper">
            <div className="container-fluid">
              <button className="btn btn-link mt-3" id="menu-toggle">
                <FontAwesomeIcon icon={faList} />
              </button>
              <h4 className="mt-2 man_hadding mb-3">
                Change Your User Password
              </h4>
              <div className="in_page row">
                <br />

                <div className="col-md-8">
                  <div className="man_white_box">
                    <div className=" padding_d">
                      <ul className="nav nav_left_tab">
                        <li className="nav-item">
                          <a
                            className="active show"
                            data-toggle="tab"
                            href="#details"
                          >
                            <i className="la la-mobile-phone l_i"></i>
                            Change Your User Password
                          </a>
                        </li>
                      </ul>
                      <hr />
                      <form
                        noValidate
                        onSubmit={this.onUpdateBalance}
                        id="add-user"
                      >
                        <div className="white_box">
                          <div className="tab-content ">
                            <div className="tab-pane active show" id="details">
                              <div className="row mt-2">
                                <div className="col-md-3">
                                  <label htmlFor="email">Email</label>
                                </div>
                                <div className="col-md-9">
                                  <input
                                    onChange={this.onChange}
                                    error={errors.email}
                                    name="email"
                                    type="email"
                                    className={classnames("form-control", {
                                      invalid: errors.email,
                                    })}
                                  />
                                </div>
                                {""}
                                <div className="col-md-3">
                                  <label htmlFor="password">
                                    Current Password
                                  </label>
                                </div>
                                <div className="col-md-9 eye_pass">
                                  <input
                                    onChange={this.onChange}
                                    name="OldPassword"
                                    value={this.state.OldPassword}
                                    type={this.state.type}
                                    className={classnames("form-control", {
                                      invalid: errors.email,
                                    })}
                                  />
                                  <span
                                    className="password__show eye1"
                                    onClick={this.handleClick}
                                  >
                                    {this.state.type === "text" ? (
                                      <i className="las la-eye"></i>
                                    ) : (
                                      <i className="las la-low-vision"></i>
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-md-3">
                                  <label htmlFor="amount">New Password</label>
                                </div>
                                <div className="col-md-9 eye_pass">
                                  <input
                                    onChange={this.onChange}
                                    value={this.state.NewPassword}
                                    name="NewPassword"
                                    type={this.state.type}
                                    className={classnames("form-control", {
                                      invalid: errors.amount,
                                    })}
                                  />
                                  <span
                                    className="password__show eye1"
                                    onClick={this.handleClick1}
                                  >
                                    {this.state.type1 === "text" ? (
                                      <i className="las la-eye"></i>
                                    ) : (
                                      <i className="las la-low-vision"></i>
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div className="col-md-3">
                                  <label htmlFor="amount">
                                    Confirm Password
                                  </label>
                                </div>
                                <div className="col-md-9">
                                  <input
                                    onChange={this.onChange}
                                    error={errors.amount}
                                    name="CPassword"
                                    type="password"
                                    value={this.state.CPassword}
                                    className={classnames("form-control", {
                                      invalid: errors.amount,
                                    })}
                                  />
                                </div>
                              </div>
                              <hr />
                              <button
                                className="btn btn-primary "
                                type="submit"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ToastContainer />
        </div>
      </div>
    );
  }
}

PasswordChange.propTypes = {
  addRoleData: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  roledata: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  roledata: state.roledata,
  errors: state.errors,
});
export default connect(mapStateToProps, { addRoleData })(
  withRouter(PasswordChange)
);
